import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { authHeader, handleResponse } from '../../Helpers';
import 'moment/locale/fr'
import Moment from 'react-moment'

import { useTranslation } from 'react-i18next';
import EnglishResourceBundle from './locale/formTerms.en.json'
import FrenchResourceBundle from './locale/formTerms.fr.json'

import './formTerms.css'

export const FormTerms = props => {
    const ReactMarkdown = require('react-markdown/with-html');

    const { t, i18n } = useTranslation();
    i18n.addResourceBundle('en', 'formTerms', EnglishResourceBundle);
    i18n.addResourceBundle('fr', 'formTerms', FrenchResourceBundle);

    const { clientKey, formKey, termId } = useParams();
    const [state, setState] = useState({ terms: [] });
    const [locale, setLocale] = useState("")

    const getLocalizeValue = (obj, culture, name) => {
        let localizeObj = obj && obj[culture.substring(0, 2)] ? obj[culture.substring(0, 2)] : null;

        if (localizeObj == null) {
            const keys = Object.keys(obj);
            if (keys.length > 0)
                localizeObj = obj[keys[0]];
        }

        if (localizeObj == null)
            return "";

        return localizeObj[name] ? localizeObj[name] : "";
    }

    useEffect(() => {
        if (!i18n.language)
            return;

        const locale =i18n.language.substring(0, 2);
        setLocale(locale);

        const request = {
            method: "GET",
            headers: authHeader()
        }

        const routeModifier = formKey && formKey.length > 0 ? `/forms/${formKey}` : "";
        const route = `${process.env.REACT_APP_APIURL}/api/clients/${clientKey}${routeModifier}/terms/${termId}?culture=${locale}`;

        fetch(route, request)
            .then(handleResponse)
            .then(setState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    return (
        <div className="terms">
            <div className="container">
                <ul className="list-inline infos mb-0 text-right">
                    <li className="list-inline-item"><small className="text-muted">{t("formTerms:version")} <b>{getLocalizeValue(state.terms, locale, "version")}</b></small></li>
                    <li className="list-inline-item"><small className="text-muted">{t("formTerms:modificationDate")} <b><Moment utc local locale={locale} date={getLocalizeValue(state.terms, locale, "modificationDate")} format="LLLL"></Moment></b></small></li>                    
                </ul>
                <ReactMarkdown source={getLocalizeValue(state.terms, locale, "content")} escapeHtml={false} />                
            </div>
        </div>
    );
}